export default __webpack_public_path__ + "static/media/notification-filled.bc46116a.svg";